<template>
  <div>
    <el-drawer
      :visible.sync="changVisible"
      :title="title"
      size="300px"
      :before-close="$onClose"
      destroy-on-close
    >
      <el-checkbox-group v-model="checkList">
        <div>
          <el-checkbox label="学号" disabled></el-checkbox>
        </div>
        <div>
          <el-checkbox label="中文姓名" disabled></el-checkbox>
        </div>
        <div>
          <el-checkbox label="英文姓名" disabled></el-checkbox>
        </div>
        <div>
          <el-checkbox label="入学年份"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="深造状态"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="工作状态"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="邮箱是否激活"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="帐号是否激活"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="专业"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="学部"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="出生年份"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="性别"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="国家地区"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="身份证号"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="招生类型"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="荣誉分类"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="毕业年份"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="联系电话"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="校友邮箱"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="常用邮箱"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="微信"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="籍贯-省份"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="籍贯-城市"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="生源地"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="生源高中"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="标签"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="校友福利"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="校友类别"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="会员类别"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="是否本硕连读"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="校友状态"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="工作所在地"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="工作单位名称"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="工作单位性质"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="工作行业类型"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="工作职位"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="工作薪酬范围"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="工作公司注册地"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="工作雇员人数"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="工作年营业额"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="工作从事何种自由职业"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="深造所在地"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="深造院校名称"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="深造院校专业"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="深造毕业年份"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="深造其他"></el-checkbox>
        </div>
      </el-checkbox-group>
    </el-drawer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      changVisible: false,
      title: "勾选表格显示字段",
      checkList: []
    };
  },
  methods: {
    $onClose(done) {
      this.$emit("toBackCheckList", this.checkList);
      done();
    },
    //页面初始化时加载的事件
    show(list) {
      this.checkList = list;
      this.changVisible = true;
    },
    // 还原
    onBack() {
      this.changVisible = false;
    }
  }
};
</script>
<style lang="less" scoped>
div {
  margin-left: 30px;
}
.this_table {
  width: 50%;
  margin: 0 auto;
}
.btn_back {
  float: right;
  margin-right: 30px;
}

.el-checkbox-group {
  max-height: 80vh;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/drawer/usersTableLabelDrawer.vue